import React from 'react'
import injectStyles from 'react-jss'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Form from 'Components/Form'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { styles } from './styles'

const ChartHeader = ({ form, classes, handleFormChange, from, to }) => (
  <Box className={classes.formWrap}>
    <Form onUpdate={handleFormChange}>
      <Grid container justify="flex-start" item xs={10}>
        <Grid container alignItems="center" justify="space-evenly" item xs={4}>
          <Typography>Between</Typography>
          <SelectDashboard
            bgTransparent
            heightAuto
            options={from}
            value={form.from}
            name="from"
          />
        </Grid>
        <Grid container alignItems="center" justify="flex-start" item xs={3}>
          <Typography>and</Typography>
          <SelectDashboard
            bgTransparent
            heightAuto
            options={to}
            value={form.to}
            name="to"
          />
        </Grid>
      </Grid>
    </Form>
  </Box>
)

export default injectStyles(styles)(ChartHeader)



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/Charts/ChartHeader/index.js